import z from "zod";
import { OrgMemberRoleEnum, sessionRoleSchema, userSchema } from "../users";
import { timestampsSchema } from "../helpers";
import { featureFlagsUpdateSchema, storedFeatureFlagsSchema } from "./feature-flags";
export const organizationSchema = z.object({
    id: z.number(),
    name: z.string(),
    featureFlags: storedFeatureFlagsSchema,
    ...timestampsSchema
});
export const updateOrganizationRequestSchema = z.object({
    name: z.string().min(1).max(256),
});
export const updateFeatureFlagsRequestSchema = z.object({
    featureFlags: featureFlagsUpdateSchema,
});
export var InvitationStatusEnum;
(function (InvitationStatusEnum) {
    InvitationStatusEnum["PENDING"] = "PENDING";
    InvitationStatusEnum["ACCEPTED"] = "ACCEPTED";
    InvitationStatusEnum["DECLINED"] = "DECLINED";
    InvitationStatusEnum["EXPIRED"] = "EXPIRED";
})(InvitationStatusEnum || (InvitationStatusEnum = {}));
export const organizationMemberSchema = z.object({
    user: userSchema,
    role: z.nativeEnum(OrgMemberRoleEnum),
});
export const organizationMembersResponseSchema = z.object({
    members: z.array(organizationMemberSchema),
});
export const assignableRoleEnum = z.enum([OrgMemberRoleEnum.ADMIN, OrgMemberRoleEnum.MEMBER]);
export const updateMemberRoleSchema = z.object({
    role: assignableRoleEnum,
});
export const organizationListItemSchema = z.object({
    id: z.number(),
    name: z.string(),
    role: sessionRoleSchema,
});
export const invitationSchema = z.object({
    id: z.number(),
    email: z.email(),
    organizationName: z.string(),
    status: z.nativeEnum(InvitationStatusEnum),
    role: assignableRoleEnum,
    expiresAt: z.string(),
    createdAt: z.string(),
});
//# sourceMappingURL=organizations.schema.js.map